import styled, { css } from "styled-components";

export const Container = styled.div`
    padding: 1rem 0 0 0;
    text-align: center;
    height: 100%;
    width: 100%;

    display: flex;
    flex-direction: column;

    h2{
        margin-bottom: 1rem;
    }

    .backToMenu{
        color: #FFF;
        
        border: none;
        background: #7A05A7;
        padding: 0.5rem;
        border-radius: 5px;
        max-width: 128px;

        display: flex;
        align-items: center;
        justify-content: center;
        gap: 0.5rem;
    }
`

export const CountriesContainer = styled.div`
    overflow-y: auto;
    margin-bottom: 4rem;
    
    
    &::-webkit-scrollbar-track {
        background-color: #FFF;
    }

    &::-webkit-scrollbar {
        width: 5px;
    }

    &::-webkit-scrollbar-thumb {
        background: #C3C3C3;
        border-radius: 4px;
    }

    scrollbar-width: thin;
    scrollbar-color: #C3C3C3;
    scrollbar-track-color: #FFF;
`

export const ContainerButton = styled.div`
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    margin: 0 20px 20px 20px;

    background: #FFF;

    ${props => props.isDisabled && css`
        button{
            opacity: 0.5;
            pointer-events: none;
        }
    `}
`